.breadcrumbs {
  color: var(--tuna-palette-action-disabled);
}

.typeLabel {
  display: inline;
}

.listItemText {
  overflow: hidden;
  padding-right: 32px;
}

.primaryText {
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}
